import { render, staticRenderFns } from "./address-book.vue?vue&type=template&id=8c23cb22&scoped=true"
import script from "./address-book.vue?vue&type=script&lang=js"
export * from "./address-book.vue?vue&type=script&lang=js"
import style0 from "./address-book.vue?vue&type=style&index=0&id=8c23cb22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c23cb22",
  null
  
)

export default component.exports